import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { memo } from 'react';
import type { SemiCircleDonutChartProps as Props } from './types';

export const SemiCircleDonutChart = memo(({ options }: Props) => {
  return <HighchartsReact highcharts={Highcharts} options={options} />;
});
// const options = {
//   chart: {
//     plotBackgroundColor: null,
//     plotBorderWidth: 0,
//     plotShadow: false,
//   },
//   title: {
//   },
//   tooltip: {
//     pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
//   },
//   accessibility: {
//     point: {
//       valueSuffix: '%',
//     },
//   },
//   plotOptions: {
//     pie: {
//       dataLabels: {
//         enabled: true,
//         distance: -50,
//         useHTML: true,
//         style: {
//           fontWeight: 'bold',
//           color: 'white',
//         },
//         format: '<span style="background: #ffffff;color: #000000;font-size: 10px;padding: 8px;border-radius: 6px;border: 1px solid #DFE3E8;">{point.name}</span>',
//       },
//       startAngle: -90,
//       endAngle: 90,
//       center: ['50%', '75%'],
//       size: '110%',
//     },
//   },
//   series: [
//     {
//       type: 'pie',
//       name: 'Browser share',
//       innerSize: '50%',
//       data: [
//         ['Chrome', 73.86],
//         ['Edge', 11.97],
//         ['Firefox', 5.52],
//         ['Safari', 2.98],
//         ['Internet Explorer', 1.9],
//         ['Other', 3.77],
//       ],
//       colors: [
//         '#1851EF',
//         '#544FC5',
//         '#00E272',
//         '#FE6A35',
//         '#6B8ABC',
//         '#FFC6C6',
//         '#030F30',
//       ],
//     },
//   ],
// };

//   return (
//     <Styled.Wrapper
//       className={classnames('SemiCircleDonutChart', className)}
//       sx={SX.root}
//     >
//       <HighchartsReact highcharts={Highcharts} options={options} />
//     </Styled.Wrapper>
//   );
// });

SemiCircleDonutChart.displayName = 'SemiCircleDonutChart';
